import styled from 'styled-components';
import Input from '../../Atoms/Input/Input';
import { media } from '../../../theme/shared/size';
import spacing from '../../../theme/shared/spacing';
import searchIcon from './assets/search.svg';
var Wrapper = styled.div.withConfig({
  displayName: "SearchInputstyle__Wrapper",
  componentId: "sc-1y1iity-0"
})(["width:100%;max-width:1440px;margin:auto;"]);
var InnerWrapper = styled.div.withConfig({
  displayName: "SearchInputstyle__InnerWrapper",
  componentId: "sc-1y1iity-1"
})(["margin:", " auto;padding:0 calc((4 * ", "));"], spacing('md'), spacing('xsm'));
var Form = styled.form.withConfig({
  displayName: "SearchInputstyle__Form",
  componentId: "sc-1y1iity-2"
})(["display:flex;flex-wrap:no-wrap;margin:", " auto;width:100%;border-bottom:4px solid ", ";overflow:hidden;", "{padding-bottom:", ";}"], spacing('xl'), function (_ref) {
  var theme = _ref.theme;
  return theme.color('red');
}, media('small'), spacing('sm'));
var SearchWrapper = styled.div.withConfig({
  displayName: "SearchInputstyle__SearchWrapper",
  componentId: "sc-1y1iity-3"
})(["width:90%;padding:0 ", ";"], spacing('sm'));
var SearchField = styled(Input).withConfig({
  displayName: "SearchInputstyle__SearchField",
  componentId: "sc-1y1iity-4"
})(["margin:0;font-size:", ";max-width:100%;border:0;outline:", ";:focus{border:0;}", "{height:100px;font-size:", ";}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontSize('md');
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.color('red');
}, media('small'), function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontSize('xxl');
});
var ActionWrapper = styled(SearchWrapper).withConfig({
  displayName: "SearchInputstyle__ActionWrapper",
  componentId: "sc-1y1iity-5"
})(["margin:", ";width:60px;", "{width:70px;}"], spacing('none'), media('small'));
var ActionButton = styled(SearchField).withConfig({
  displayName: "SearchInputstyle__ActionButton",
  componentId: "sc-1y1iity-6"
})(["text-indent:-9999px;background-color:", ";mask:url(", ") no-repeat right center;@media all and (-ms-high-contrast:none),(-ms-high-contrast:active){background:url(", ") no-repeat right center;}mask-size:45%;appearance:none;", "{mask-size:100%;}"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.color('grey_for_forms');
}, searchIcon, searchIcon, media('small'));
export { Wrapper, InnerWrapper, Form, SearchWrapper, SearchField, ActionWrapper, ActionButton };